﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKViewport from '@tk/basics/tk.viewport';
import TKDialog from '@tk/components/tk.dialog';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKHeadingNav from '@tk/components/tk.heading.nav';
import TKFileLink from '@tk/components/tk.file.link';
import TKLightGallery from '@tk/components/tk.light.gallery';

import '@uppy/dashboard/dist/style.min.css';
import '@uppy/core/dist/style.min.css';
import '@scss/modules/staticcontent.scss';

export default class Staticcontent extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-file-upload-area', constructor: TKFileUploadArea },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-heading-nav', constructor: TKHeadingNav },
            { name: 'tk-file-link', constructor: TKFileLink },
            { name: 'tk-light-gallery', constructor: TKLightGallery },
        ]);
    }
}

new Staticcontent();
